import { DefaultApiService } from '@rrze/vue-encore'

export const VUE_APP__APP_API_ENDPOINT = process.env.VUE_APP__APP_API_ENDPOINT

export class _AppApiService {
  constructor (axios = null) {
    this.defaultApiService = new DefaultApiService(VUE_APP__APP_API_ENDPOINT, axios)
  }

  list (endpoint, params) {
    return this.defaultApiService.list(endpoint, params)
  }
}

export default _AppApiService
